import { Ably } from "@pankod/refine-ably";

export const ablyClient = new Ably.Realtime(
    "BCHMIw.xW3bxw:AQEBlBsz5hKMRNp2Gg2IW6UgxaTxsWKzm8Np_OyKSUw",
);